import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./service/store";
import vuetify from "./plugins/vuetify";
import VueJWT from "vuejs-jwt";
import jwt from "@/service/jwt.service";
import 'ant-design-vue/dist/antd.css';
Vue.use(VueJWT, {
    ignoreExpiration: true
});

import ApiService from "./service/api.service";
import HideToggler from "@/components/hide-toggle.vue";
import "./assets/font/style.css";
import "./assets/scss/main.scss";
import "@/plugins/perfect-scrollbar";
import "@/plugins/apexcharts";
import "@mdi/font/css/materialdesignicons.css";

import "bootstrap/scss/bootstrap.scss";

Vue.config.productionTip = false;

ApiService.init();

router.beforeEach((to, from, next) => {
    if (to.meta.roles) {
        const isRouled = jwt.isRouled(to);
        if (isRouled) {
            next();
        } else {
            if (to.name == "home") {
                router.push("/log-in");
            } else {
                router.push("/access-denied");
            }
        }
    } else {
        next();
    }
    document.title = to.meta.title;
    router.options.routes[0].children.filter(route => {
        if (route.name == to.name) {
            store.dispatch("setLoading", true);
        }
    });
    // Scroll page to top on every route change
    setTimeout(() => {
        store.dispatch("setMiniDrawer", true);
        window.scrollTo(0, 0);
    }, 100);
});

var formatDate = function(date) {
    return new Date(date).toLocaleDateString("en-UK", {
        weekday: "long",
        year: "numeric",
        month: "2-digit",
        day: "numeric",
        hour12: true,
        hour: "2-digit",
        minute: "numeric"
    });
};
Vue.filter("formatDate", formatDate);
Vue.component("hide-toggler", HideToggler);
new Vue({
    router,
    store,
    vuetify,
    VueJWT,
    render: h => h(App)
}).$mount("#app");
